if (!customElements.get('product-modal')) {
  customElements.define('product-modal', 
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        console.log('ProductModal initialized');
      }

      hide() {
        console.log('Modal hide called');
        super.hide();
      }

      show(opener) {
        console.log('Modal show called with opener:', opener);
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        console.log('showActiveMedia called');
        // First hide all media that don't match the opened media
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        console.log('Media ID from opener:', mediaId);

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          console.log('Found media element with ID:', element.getAttribute('data-media-id'));
          if (element.getAttribute('data-media-id') !== mediaId) {
            element.classList.remove('active');
          }
        });

        // Show the active media
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        console.log('Found active media:', activeMedia);

        if (!activeMedia) {
          console.log('No active media found for ID:', mediaId);
          return;
        }

        activeMedia.classList.add('active');
        console.log('Added active class to media');

        // Handle scrolling and positioning
        const container = this.querySelector('[role="document"]');
        if (container) {
          console.log('Found container, setting up scroll');
          setTimeout(() => {
            activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            if (activeMedia.offsetWidth) {
              container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;
            }
          }, 100);
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMedia.querySelector('template')
        ) {
          console.log('Loading deferred media content');
          activeMedia.loadContent();
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, setting up click listeners');
  
  // Find all modal opener buttons
  const modalOpeners = document.querySelectorAll('.product__modal-opener--image button');
  console.log('Found modal openers:', modalOpeners.length);
  
  modalOpeners.forEach(button => {
    button.addEventListener('click', (e) => {
      console.log('Modal opener button clicked');
      console.log('Button data-media-id:', button.getAttribute('data-media-id'));
      console.log('Button parent modal-opener data-modal:', button.closest('modal-opener')?.getAttribute('data-modal'));
    });
  });
});